// extracted by mini-css-extract-plugin
export default {"cardNotif":"NotifDesktop_cardNotif__-8Djs","productImg":"NotifDesktop_productImg__+g2id","icon":"NotifDesktop_icon__Xn7N4","navbar-toggle":"NotifDesktop_navbar-toggle__tn7zr"};